import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { FolderOpen, Loader2, ExternalLink } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResourcesPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (!authLoading && !user) navigate("/login"); }, [user, authLoading, navigate]);

  useEffect(() => {
    axios.get(`${API}/resources`).then(res => setResources(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (authLoading || !user) return null;

  return (
    <div data-testid="resources-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Library</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Resources</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white min-h-[50vh]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-20"><Loader2 className="w-6 h-6 text-[#C8A97E] animate-spin mx-auto" /></div>
          ) : resources.length === 0 ? (
            <div className="text-center py-20">
              <FolderOpen className="w-12 h-12 text-[#E5E2DC] mx-auto mb-4" />
              <p className="text-[#595959]">No resources available yet. Check back soon.</p>
            </div>
          ) : (
            <div className="space-y-4">
              {resources.map((r) => (
                <div key={r.id} data-testid={`resource-${r.id}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-6">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="font-serif text-base font-semibold text-[#1C2E4A] mb-1">{r.title}</h3>
                      <p className="text-sm text-[#595959]">{r.description}</p>
                    </div>
                    {r.url && (
                      <a href={r.url} target="_blank" rel="noopener noreferrer" className="text-[#C8A97E] hover:text-[#B3956A] shrink-0">
                        <ExternalLink className="w-4 h-4" />
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
